module.exports = __webpack_public_path__ + "img/left_dots_pattern.750b532a.svg";